import { FixaAccordionItem } from "../../../wrappers/FixaAccordion/FixaAccordion";
import { FixaListViewItem } from "../../../wrappers/FixaListView/FixaListViewItem";
import {
  FilterValue,
  SelectGroup,
  SelectOption,
  StringFilterValue,
} from "../../types/filter";
import {
  getSelectOptionKey,
  isSelectOption,
  isSelectOptionSelected,
} from "../../utils/filter/selectoption";
import { localeIncludes } from "./SelectListView.helper";
import FilterAccordionCss from "../FilterAccordion/FilterAccordion.module.css";
import { FixaListView } from "../../../wrappers/FixaListView/FixaListView";

interface GroupSelectListItemProps {
  item: SelectGroup;
  prefix: string;
  selected: FilterValue;
  searchInput: string;
  onChange: (option: SelectOption) => void;
  defaultValue: StringFilterValue;
}

export const GroupSelectListItem = ({
  item,
  prefix,
  selected,
  searchInput,
  onChange,
  defaultValue,
}: GroupSelectListItemProps) => {
  const { options, title } = item;
  const groupOptionValues = options.map(({ value }) => value);
  const groupDefaultFilterValue = groupOptionValues.includes(defaultValue.value)
    ? defaultValue.value
    : "";
  const groupSelectedFilterValue = groupOptionValues.includes(
    (selected as StringFilterValue).value
  )
    ? selected.value
    : "";

  const filterValueCount =
    groupDefaultFilterValue === groupSelectedFilterValue ? 0 : 1;
  const filteredOptions = options.filter(
    (option) =>
      !isSelectOption(option) ||
      isSelectOptionSelected(selected, option) ||
      localeIncludes(option.title, searchInput)
  );

  if (!filteredOptions.length) {
    return null;
  } else {
    const optionKey = getSelectOptionKey("selectgroup", item);
    return (
      <FixaAccordionItem
        id={`filter-option-accordion-${optionKey}`}
        data-testid={`filter-accordion-${optionKey}`}
        title={filterValueCount ? `${title} (${filterValueCount})` : title}
        className={FilterAccordionCss["accordion-item-title"] ?? ""}
        open={true}
      >
        <FixaListView
          id={`listview-option-accordion-${prefix}-${optionKey}}`}
          data-testid={`listview-option-accordion-${prefix}-${optionKey}}`}
          size="small"
          showDivider={false}
        >
          {filteredOptions.map((option, idx) => {
            const { value } = option;
            const isSelected = isSelectOptionSelected(selected, option);
            return (
              <FixaListViewItem
                key={getSelectOptionKey(idx, option)}
                inset
                onChange={() => {
                  onChange(option);
                }}
                control="radiobutton"
                controlProps={{
                  value: isSelected ? "ON" : "OFF",
                  checked: isSelected,
                }}
                showDivider={false}
                title={option.title}
                data-testid={`listview-option-${prefix}-${value}`}
              />
            );
          })}
        </FixaListView>
      </FixaAccordionItem>
    );
  }
};
